// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const StyledIcon = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
}));

// ----------------------------------------------------------------------

InnerAppAnalytics.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  title1: PropTypes.string,
  title2: PropTypes.string,
  total: PropTypes.number,
  total1: PropTypes.number,
  total2: PropTypes.number,
  sx: PropTypes.object,
};

export default function InnerAppAnalytics({ title1, total1, title2, total2,title, total, icon, color = 'primary', sx, ...other }) {
  return (
    <Card
      sx={{
        py: 5,
        boxShadow: 0,
        textAlign: 'center',
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
        ...sx,
      }}
      {...other}
    >
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>
      <Typography variant="h3">{fShortenNumber(total)}</Typography>

        <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title2}
        </Typography>
        <Typography variant="h3">{fShortenNumber(total2)}</Typography>
        
          <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
            {title1}
          </Typography>
          <Typography variant="h3">{fShortenNumber(total1)}</Typography>
      
      
      
    </Card>
  );
}
